export const stripImageData = (obj: any) => {
  const newObj = { ...obj }
  delete newObj.imageFile
  delete newObj.imagePreviewUrl
  delete newObj.images
  delete newObj.image
  return newObj
}
